export default __webpack_public_path__ + "static/media/transicion.ae74d3bc.png";